<template>
  <div v-if="branch">
    <!-- title -->
    <p class="title is-4 is-spaced">{{ branch.branch }}</p>

    <!-- tabs -->
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'branch-general' }" active-class="is-active" tag="li" exact><a>General</a></router-link>
        <router-link :to="{ name: 'branch-games-general' }" active-class="is-active" tag="li"><a>Games</a></router-link>
        <router-link :to="{ name: 'branch-settings-bonuses' }" active-class="is-active" tag="li"><a>Bonuses settings</a></router-link>
        <router-link :to="{ name: 'branch-jackpots' }" active-class="is-active" tag="li"><a>Jackpots</a></router-link>
        <router-link :to="{ name: 'branch-bk-settings' }" active-class="is-active" tag="li"><a>Bk Settings</a></router-link>
        <router-link :to="{ name: 'branch-paymentmethods' }" active-class="is-active" tag="li"><a>Payment Methods</a></router-link>
      </ul>
    </div>

    <!-- router view -->
    <router-view />
  </div>
</template>
<script>
  import branchService from "../../../../../services/branch.service"
  import breadcrumbsService from "../../../../../services/breadcrumbs.service"

  export default {
    name: 'client-branch',
    data() {
      return {
        branch: null
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      branchName() {
        return this.$route.params.branch;
      }
    },
    async mounted() {
      await this.loadBranch();
      breadcrumbsService.dynamic.set({ key: "branch", func: () => this.branch.branch });
    },
    methods: {
      async loadBranch() {
        this.branch = await branchService.get(this.clientId, this.branchName);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/index.vue